"use strict";

jQuery(document).ready(function ($) {
  $('.news-strip__ticker').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});